
<mat-label class="subHeading">Insurer Email ID<span class="star">*</span></mat-label>
<input type="email" formControlName="insurer_email" class="rule"/>
<mat-error *ngIf="form.controls['insurer_email'].invalid && form.controls['insurer_email'].touched">
    Invalid Email Format
</mat-error>
